import React, { useCallback } from 'react';
import FormControl from '@mui/material/FormControl';
import RadioGroup, { RadioGroupProps } from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { DropdownOption } from 'components/DropdownSelect/dropdown.types';

interface SingleChoiceQuestionProps {
  options: DropdownOption[];
  onChange: (newValue?: DropdownOption) => void;
  value?: DropdownOption;
  name?: string;
  radioGroupProps?: Partial<RadioGroupProps>;
  disabled?: boolean;
}

type Props = SingleChoiceQuestionProps;

const SingleChoiceQuestion = ({
  options,
  value,
  onChange,
  name,
  radioGroupProps,
  disabled,
}: Props) => {
  const currentValue = value?.id;

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const newId = (event.target as HTMLInputElement).value;
      const newOption = options.find((option) => option.id.toString() === newId.toString());
      onChange(newOption);
    },
    [onChange, options]
  );

  return (
    <FormControl>
      <RadioGroup {...radioGroupProps} name={name} value={currentValue} onChange={handleChange}>
        {options.map((option) => (
          <FormControlLabel
            key={option.id}
            value={option.id}
            control={<Radio color='default' />}
            label={option.name}
            disabled={disabled}
            sx={{
              color: (theme) => theme.colors.neutral600,
              '.MuiFormControlLabel-label.Mui-disabled': {
                color: (theme) => theme.colors.neutral600,
              },
            }}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default SingleChoiceQuestion;
